var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"textContainer",style:(_vm.componentStyle)},[_vm._v(" "+_vm._s(_vm.conf.preText + _vm.formatTime + _vm.conf.sufText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }